import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SchemeDetail from './components/SchemeDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageScheme',
  components: {
    SchemeDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;